import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoVendedorEstado(props) {
    
    const options = {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        title: {
          text: 'Vendedor - Control de Comprobantes por Estado',
          align: 'left',
          offsetX: 110
        },
        series: props.series,
        colors: ['#008ffb', '#8cd369', '#feb019', '#E91E63'],
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom'
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: props.vendedores
        },
        yaxis: [{
          title: {
            text: 'Cantidad Comprobantes',
          },
          labels: {
            formatter : function (val) {
              return global.decimalFormat(parseInt(val))
            }
          }
        }],
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      }
      ;
    return (
        <div id="chart">
            <Chart options={options} series={options.series} type="bar" height={350} />
        </div>
    );
}